/**
 * @generated SignedSource<<8d9952586880ccd9a27f1488767df058>>
 * @relayHash a9cd468cc7d0e510656c933a0f5cfc19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9fa48921cef6083855f0594c590f0a4623a1bf99ebe36fdf36903e4ee8b64caf

import type { ConcreteRequest } from 'relay-runtime';
export type sendContentAgeAnalyticsGetContentAgeQuery$variables = {
  contentId: string;
};
export type sendContentAgeAnalyticsGetContentAgeQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly createdDate: string | null;
      } | null;
      readonly id: string | null;
      readonly version: {
        readonly when: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type sendContentAgeAnalyticsGetContentAgeQuery = {
  response: sendContentAgeAnalyticsGetContentAgeQuery$data;
  variables: sendContentAgeAnalyticsGetContentAgeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "current",
          "draft"
        ]
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "createdDate"
              }
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "when"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "sendContentAgeAnalyticsGetContentAgeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendContentAgeAnalyticsGetContentAgeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a9cd468cc7d0e510656c933a0f5cfc19",
    "id": "9fa48921cef6083855f0594c590f0a4623a1bf99ebe36fdf36903e4ee8b64caf",
    "metadata": {},
    "name": "sendContentAgeAnalyticsGetContentAgeQuery",
    "operationKind": "query",
    "text": "query sendContentAgeAnalyticsGetContentAgeQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,history{createdDate},version{when}}}}"
  }
};
})();

(node as any).hash = "b714b9334919637eb6a47f1f5260ef2d";

export default node;
